<template>
  <div class="base">
    <inside-header title="我的服务包" back-link-name="TeacherIndex" />
    <div class="main">
      <a-alert v-if="approved === 0" message="还未通过审核" description="教员您好，您的资料还未通过平台审核。通过审核后用户才能看到您的服务包" type="info" />
      <div v-else>
        <div class="list">
          <div v-for="(item, key) in dataList" :key="key" class="item" @click="gotoPackInfo(item.id)">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="info">
              <span class="label">已报名</span>
              <span class="num">{{ item.apply_count }}人</span>
            </div>
          </div>
        </div>
        <div class="btn-area">
          <a-button block="" @click="addPack()">
            <span class="icon">
              <van-icon name="plus" />
            </span>
            <span class="label">添加服务包</span>
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'
const columns = [
  {
    title: '名称',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '描述信息',
    dataIndex: 'desc',
    key: 'desc'
  },
  {
    title: '有效期至',
    dataIndex: 'end_time',
    key: 'endTime',
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'TutorPay',
  components: {
    InsideHeader
  },
  data() {
    return {
      dataList: [],
      columns,
      loading: true,
      approved: 1
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      // 加载数据
      this.loading = true
      this.$http({
        url: '/index/teacher/servicePackList',
        method: 'get',
        params: {}
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          console.log(data)
          this.dataList = data.list
          this.approved = data.approved
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    onDelete(packId) {
      this.$http({
        url: '/index/teacher/servicePackDelete',
        method: 'post',
        params: {
          id: packId
        }
      }).then(res => {
        if (res.status === 'success') {
          this.$notification.success({
            message: '成功',
            description: '删除服务包成功'
          })
          // 删除数据后，重新加载数据
          this.loadData()
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    addPack() {
      this.$router.push({ name: 'TeacherPackInfo' })
    },
    gotoPackInfo(id) {
      this.$router.push({ name: 'TeacherPackInfo', query: { id: id } }) // 通过路由传参，然后用props: (route) => ({ id: route.params.id })接收
    }
  }
}
</script>
<style lang="stylus" scoped>
.base {
  min-width: 280px;
  max-width: 420px;
  margin: auto;
  background-color: #fff;
}

.main {
  padding: 15px;

  .list {

    .item {
      padding: 20px 20px;
      background-color: #f6f6f6;
      border-radius: 10px;
      margin-bottom: 10px;

      .title {
        font-family: PingFang-SC-Bold;
        font-size: 16px;
        line-height: 21px;
        color: #333333;
        font-weight: bold;
      }

      .info {
        margin-top: 5px;
        .label {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 28px;
          color: #666666;
        }

        .num {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 28px;
          color: #666666;

          margin-left: 5px;
        }
      }
    }
  }

  .btn-area {
    margin-top: 10px;

    button {
      height: 40px;
      background-color: #ffffff;
      border-radius: 20px;
      border: solid 1px #ffe8db;
      color: $theme-color;

      .icon {
        position: relative;
        top: 2px;
      }

      .label {
        margin-left: 3px;
      }
    }
  }

}
</style>
